import { render } from "./infoProjectPopup.vue?vue&type=template&id=6f9eef0d&scoped=true"
import script from "./infoProjectPopup.vue?vue&type=script&lang=js"
export * from "./infoProjectPopup.vue?vue&type=script&lang=js"

import "../../../less/_projects_popup.less?vue&type=style&index=0&id=6f9eef0d&scoped=true&lang=less&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9eef0d"]])

export default __exports__